import React, { useEffect } from 'react'
import { withStyles, Typography, Button, Tooltip } from '@material-ui/core'
import { data } from './components'
import { Icon } from '@iconify/react'
import styles from './styles'
import { useDispatch, useSelector } from 'react-redux'
import {
  editSectionOrderAction,
  setEndingCard,
} from 'src/reducers/course/action'
import { courseRemoveCard } from 'src/reducers/card/action'
import { SectionTypes } from 'src/model/card'
import clsx from 'clsx'
const LastPageHeader = props => {
  const { classes, sections, setSections, cardData, isEndingCardExist } = props
  const course = useSelector(state => state.course.course)
  const [open, setOpen] = React.useState(isEndingCardExist ? false : true)
  const onClickChange = () => {
    setOpen(!open)
  }
  useEffect(() => {
    if (isEndingCardExist) {
      setOpen(false)
    }
  }, [isEndingCardExist])

  const dummyData = data.find(x => x.type === cardData?.type)

  const cardType = dummyData?.title?.replace('<br/>', '')
  const icon = dummyData?.icon

  const dispatch = useDispatch()
  const handleAddEndingCard = type => {
    if (isEndingCardExist) {
      dispatch(
        courseRemoveCard(course.id, Number(cardData.id), () => {
          // Remove ending card from Redux store
          let newSections = [...sections]
          const newSection = {
            id: null,
            title: 'Ending',
            type: SectionTypes.ENDING,
            cards: [
              {
                id: null,
                type: type,
                title: 'Ending Page',
                orderOfCard: 10001,
              },
            ],
          }
          newSections.push(newSection)

          dispatch(
            editSectionOrderAction(
              course.id,
              { sections: newSections },
              response => {
                // Update local state with new IDs
                const newEndingSection =
                  response.sections[response.sections.length - 1]

                // Create ending section with proper IDs
                const endingSection = {
                  ...newSection,
                  id: newEndingSection.id,
                  cards: [
                    {
                      ...newSection.cards[0],
                      id: newEndingSection.cards[0].id,
                    },
                  ],
                }

                // Update Redux store with ending card
                dispatch(setEndingCard(endingSection.cards[0]))
                setOpen(!open)

                // Update sections state excluding ending section
                const updatedSections = [...sections].filter(
                  x => x.type !== SectionTypes.ENDING,
                )
                setSections(updatedSections)
              },
            ),
          )
        }),
      )
      return
    } else {
      let newSections = [...sections]
      const newSection = {
        id: null,
        title: 'Ending',
        type: SectionTypes.ENDING,
        cards: [
          {
            id: null,
            type: type,
            title: 'Ending Page',
            orderOfCard: 10001,
          },
        ],
      }
      newSections.push(newSection)

      dispatch(
        editSectionOrderAction(
          course.id,
          { sections: newSections },
          response => {
            // Update local state with new IDs
            const newEndingSection =
              response.sections[response.sections.length - 1]

            // Create ending section with proper IDs
            const endingSection = {
              ...newSection,
              id: newEndingSection.id,
              cards: [
                {
                  ...newSection.cards[0],
                  id: newEndingSection.cards[0].id,
                },
              ],
            }

            // Update Redux store with ending card
            dispatch(setEndingCard(endingSection.cards[0]))
            setOpen(!open)

            // Update sections state excluding ending section
            const updatedSections = [...sections].filter(
              x => x.type !== SectionTypes.ENDING,
            )
            setSections(updatedSections)
          },
        ),
      )
      return
    }
  }
  return (
    <div className={classes.root}>
      <div className={`${classes.container} ${open ? 'open' : ''}`}>
        <div className={classes.flexContainer}>
          <div className={classes.headerWrapper}>
            <Icon
              icon={icon ? icon : 'mynaui:flag-solid'}
              className={classes.icons}
              fontSize={16}
            />
            <Typography className={classes.pageTitle}>
              {cardType ? cardType : 'Customize Completion'}
            </Typography>
          </div>
          <div
            style={{
              display: isEndingCardExist ? 'flex' : 'none',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <Button
              className={classes.changeCompletionButton}
              onClick={onClickChange}
            >
              {!open && (
                <Icon
                  icon={'qlementine-icons:swap-16'}
                  className={classes.icons}
                />
              )}
              <Typography className={classes.buttonText}>
                {!open ? 'Change completion' : ''}
              </Typography>
            </Button>
          </div>
          <div
            className={classes.helpContainer}
            onClick={() => {
              window.open(
                'https://intercom.help/mini-course-generator/en/articles/7864240-customizing-the-end-completion',
                '_blank',
              )
            }}
          >
            <Icon
              icon="solar:question-circle-outline"
              fontSize={16}
              color="#002E47"
              className={classes.helpIcon}
            />
            <Typography className={classes.helpText}>How it works?</Typography>
          </div>
        </div>
        <div className={`${classes.itemWrapper} ${open ? 'open' : ''}`}>
          {data.map((item, index) => (
            <div
              key={index}
              className={clsx({
                [classes.itemContainer]: true,
                [classes.itemSelected]: item.type === cardData?.type,
              })}
              onClick={() => handleAddEndingCard(item.type)}
            >
              <Icon icon={item.icon} className={classes.icon} />
              <Typography
                className={classes.text}
                dangerouslySetInnerHTML={{ __html: item.title }}
              ></Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(LastPageHeader)
